import { useState, type FormEvent } from 'react';
import { submitReaddyForm } from '@/utils/formSubmit';

const ENDPOINT = 'https://readdy.ai/api/form/dah85vboh653ivfvnnt0';

export default function SubscribeForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    setStatus('loading');
    setMessage('');

    const result = await submitReaddyForm(
      form,
      ENDPOINT,
      'website_alt',
      '订阅成功，我们会在每个关键节点前提醒你。',
    );

    if (result.ok) {
      setStatus('success');
      setMessage(result.message);
      form.reset();
    } else {
      setStatus('error');
      setMessage(result.message);
    }
  };

  return (
    <section className="w-full px-4 md:px-6 pb-16 md:pb-24 bg-background-50">
      <div className="max-w-6xl mx-auto rounded-lg bg-primary-500 px-6 md:px-12 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
              订阅赛程提醒，别错过截稿日
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-100 leading-relaxed">
              留下邮箱，我们会在海选截稿、初赛开投、决赛截止与结果公示前分别发一次提醒，只发与赛程相关的消息。
            </p>
          </div>

          <div>
            <form
              id="subscribe-schedule-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="flex flex-col sm:flex-row gap-3"
            >
              <label htmlFor="subscribe-email" className="sr-only">
                邮箱地址
              </label>
              <input
                id="subscribe-email"
                type="email"
                name="email"
                required
                maxLength={120}
                placeholder="请输入你的邮箱地址"
                className="flex-1 rounded-md border border-primary-400 bg-background-50 px-4 py-3 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-300"
              />
              <input
                type="text"
                name="website_alt"
                className="form-guard-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-6 py-3 rounded-md bg-secondary-900 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-secondary-950 transition-colors cursor-pointer disabled:opacity-60"
              >
                {status === 'loading' ? '提交中…' : '订阅提醒'}
              </button>
            </form>

            {status === 'success' && (
              <p className="mt-3 flex items-center gap-2 text-sm text-background-50">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill"></i>
                </span>
                {message}
              </p>
            )}
            {status === 'error' && (
              <p className="mt-3 flex items-center gap-2 text-sm text-background-50">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-error-warning-fill"></i>
                </span>
                {message}
              </p>
            )}
            <p className="mt-3 text-xs text-background-100/80">我们不会向第三方分享你的邮箱，随时可回复邮件退订。</p>
          </div>
        </div>
      </div>
    </section>
  );
}